import { HeadingLevel } from '../../../components/core/Heading';
import { IntegrationCard } from './IntegrationCard';

type SingleStopCardProps = {
  headingLevel: HeadingLevel;
  linkUrl: string;
};

export const SingleStopCard = ({ headingLevel, linkUrl }: SingleStopCardProps): JSX.Element => {
  if (!linkUrl) {
    return <></>;
  }

  return (
    <IntegrationCard
      descriptionText="Get help coordinating food assistance, healthcare benefits, and financial counseling."
      headingLevel={headingLevel}
      headingText="Food, Healthcare, and Financial Support"
      linkText="Visit Single Stop"
      linkUrl={linkUrl}
      logoHeight={10}
      logoUrl="https://images.prismic.io/mantra-hub/Z-68ZHdAxsiBwSxU_SingleStopLogo.png?auto=format,compress"
      serviceName="Single Stop"
    />
  );
};
